import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue_apollo.js?vue3';
import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import createDefaultClient from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/graphql.js?vue3';
import { cacheConfig, resolvers } from '~/ci/catalog/graphql/settings';
import typeDefs from '~/ci/catalog/graphql/typedefs.graphql';
import { injectVueAppBreadcrumbs } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/breadcrumbs.js?vue3';
import { exploreCatalogIndexPath } from '~/lib/utils/path_helpers/explore';

import GlobalCatalog from './global_catalog.vue';
import CiResourcesPage from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/catalog/components/pages/ci_resources_page.vue?vue3';
import CiCatalogBreadcrumb from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/catalog/components/ci_catalog_breadcrumb.vue?vue3';
import { createRouter } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/catalog/router/index.js?vue3';

export const initCatalog = (selector = '#js-ci-cd-catalog') => {
  const el = document.querySelector(selector);
  if (!el) {
    return null;
  }

  const { reportAbusePath, legalDisclaimer } = el.dataset;

  Vue.use(VueApollo);

  const apolloProvider = new VueApollo({
    defaultClient: createDefaultClient(resolvers, { cacheConfig, typeDefs }),
  });

  const router = createRouter(exploreCatalogIndexPath(), CiResourcesPage);

  injectVueAppBreadcrumbs(router, CiCatalogBreadcrumb);

  return initVueApp({
    el,
    name: 'GlobalCatalog',
    router,
    apolloProvider,
    provide: {
      reportAbusePath,
      legalDisclaimer,
    },
    component: GlobalCatalog,
  });
};
